import { createStylesheet } from "../../../_app/utils/styles";
import { UIButton, UIGrid, UIList, UITypography } from "../../../_app/components";

export default function FilterBox({
  item,
  resetSelection,
  addSelection,
  selection,
  setSelection,
  close,
  showReset,
  disableApply,
  children,
  ...props
}: any) {
  const classes = useStyles();

  return (
    <div {...props} className={classes.root}>
      <UIList disablePadding>
        <UIGrid container direction="row" justifyContent="space-between" alignItems="center" className={classes.filterActions}>
          <div className={classes.titleCtr}>
            <UITypography variant="caption" className={classes.filterTitle}>
              Filter by {item.name}
            </UITypography>
            {item.MAX_COUNT && (
              <UITypography component="p" variant="caption">
                You can select up to {item.MAX_COUNT} item/s
              </UITypography>
            )}
          </div>
          <UIButton
            data-cy="reset-filter-button"
            size="small"
            color="inherit"
            onClick={() => resetSelection()}
            className={showReset ? classes.show : classes.hidden}
          >
            Reset
          </UIButton>
        </UIGrid>
        {children}
        <UIGrid container className={classes.filterAdd} component="div">
          <UIButton
            data-cy="add-filter-button"
            variant="contained"
            size="small"
            color="primary"
            onClick={addSelection}
            disabled={disableApply ? disableApply : selection.length < 1}
            className={classes.applyButton}
          >
            Apply
          </UIButton>
          <UIButton
            data-cy="close-filter-button"
            size="small"
            variant="text"
            color="primary"
            onClick={() => close()}
            className={classes.cancelButton}
          >
            Cancel
          </UIButton>
        </UIGrid>
      </UIList>
    </div>
  );
}

const useStyles = createStylesheet((theme) => ({
  root: {
    maxWidth: "100%",
  },
  filterActions: {
    padding: theme.spacing(2),
  },
  filterAdd: {
    padding: theme.spacing(1.5, 2),
    marginTop: theme.spacing(1),
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  filterTitle: {
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  titleCtr: {
    display: "flex",
    flexDirection: "column",
  },
  hidden: {
    display: "none",
  },
  show: {
    display: "initial",
  },
}));
